import React, { Component } from "react";
import {
  Button,
  Container,
  Row,Form,
  Col,
  Offcanvas,
  Spinner,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Audit_log_config extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...", 
      show: false,
      isSubmitting: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.audit_log_config_Id,
          sortable: true,
          cell: (row) => <span>{row.audit_log_config_Id}</span>,
        },
        {name:"Table Name",selector:(row, i) => row.tableName,sortable:true,cell: (row) => <span>{row.tableName}</span>,},{name:"Action Type",selector:(row, i) => row.actionType,sortable:true,cell: (row) => <span>{row.actionType}</span>,},{name:"Is Enabled",selector:(row, i) => row.isEnabled,sortable:true,cell: (row) => <span>{row.isEnabled}</span>,},{name:"Log Fields",selector:(row, i) => row.logFields,sortable:true,cell: (row) => <span>{row.logFields}</span>,},{name:"Retention Days",selector:(row, i) => row.retentionDays,sortable:true,cell: (row) => <span>{row.retentionDays}</span>,},{name:"Notify Config",selector:(row, i) => row.notifyConfig,sortable:true,cell: (row) => <span>{row.notifyConfig}</span>,},
        
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
              style={{marginRight:"10px"}}
                variant="primary"
                onClick={() => this.Audit_log_configeditHandler(row)}
                className="bi bi-pen" 
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 100,
      isEditing: false,
     audit_log_config_Id:"",
      tableName:'',actionType:'',isEnabled:'',logFields:'',retentionDays:'',notifyConfig:'',
      
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;
    
    let validationResult = { isValid: true, message: "" };
    
    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;
        
      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;
        
      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;
        
      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;
        
      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;
        
      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;
        
      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;
        
      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;
        
      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;
        
      default:
        validationResult = { isValid: true, message: "" };
    }
    
    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }
    
    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }
    
    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({ 
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;
    
    // Auto-generated required field validation
    // No required fields defined
    
    
    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'tableName', inputType: 'Text', displayName: 'Table Name', validationOptions: { isRequired: false } },
      { fieldName: 'actionType', inputType: 'Text', displayName: 'Action Type', validationOptions: { isRequired: false } },
      { fieldName: 'isEnabled', inputType: 'Number', displayName: 'Is Enabled', validationOptions: { isRequired: false } },
      { fieldName: 'logFields', inputType: 'Text', displayName: 'Log Fields', validationOptions: { isRequired: false } },
      { fieldName: 'retentionDays', inputType: 'Number', displayName: 'Retention Days', validationOptions: { isRequired: false } },
      { fieldName: 'notifyConfig', inputType: 'Text', displayName: 'Notify Config', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });
    
  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({ 
      show: true, 
      errors: {},
      touched: {},
      tableName:'',actionType:'',isEnabled:'',logFields:'',retentionDays:'',notifyConfig:'', 
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ 
      show: false,
      isEditing: false, 
      errors: {},
      touched: {},
      tableName:'',actionType:'',isEnabled:'',logFields:'',retentionDays:'',notifyConfig:'', 
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch(type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
     }   
  };

  Audit_log_configeditHandler = (row)=>{
      this.setState({ 
        isEditing: true,
        show: true,
        audit_log_config_Id: row.audit_log_config_Id, 
        tableName:row.tableName,actionType:row.actionType,isEnabled:row.isEnabled,logFields:row.logFields,retentionDays:row.retentionDays,notifyConfig:row.notifyConfig,
        
        errors: {},
        touched: {}
      });
  }
       
  Audit_log_configfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    
    fetch(configData.api_url +'C_Audit_log_config/list', {
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      if (data.status === "success") {
        this.setState({ data: data.list });
      }
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      this.showToast("Failed to load data", "error");
    });
  }

  Audit_log_configsubmitHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    
    // Validate all fields before submission
    this.validateAllFields();
    
    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      this.setState({ isSubmitting: false });
      return;
    }
    
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('tableName',this.state.tableName);
formData.append('actionType',this.state.actionType);
formData.append('isEnabled',this.state.isEnabled);
formData.append('logFields',this.state.logFields);
formData.append('retentionDays',this.state.retentionDays);
formData.append('notifyConfig',this.state.notifyConfig);

    
    
    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Audit_log_config/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.Audit_log_configfetchHandler();
        this.handleOffcanvasClose();
        this.setState({ tableName:'',actionType:'',isEnabled:'',logFields:'',retentionDays:'',notifyConfig:'', });
      }
    
      this.setState({ loading: false });})
    .catch((error) => {
      console.error("Submit error:", error);
      this.showToast("Failed to save data", "error");
    
      this.setState({ loading: false });}).finally(() => this.setState({ isSubmitting: false }));
  }

  Audit_log_configupdateHandler = (e) => {
    e.preventDefault();
    if (this.state.isSubmitting) return;
    this.setState({ isSubmitting: true });
    // Validate all fields before submission
    this.validateAllFields();
    
    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }
    
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("audit_log_config_Id", this.state.audit_log_config_Id);
    formData.append('tableName',this.state.tableName);
formData.append('actionType',this.state.actionType);
formData.append('isEnabled',this.state.isEnabled);
formData.append('logFields',this.state.logFields);
formData.append('retentionDays',this.state.retentionDays);
formData.append('notifyConfig',this.state.notifyConfig);

    
    
    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url +'C_Audit_log_config/update', {  
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.Audit_log_configfetchHandler();
        this.handleOffcanvasClose();
      }
    
      this.setState({ loading: false });})
    .catch((error) => {
      console.error("Update error:", error);
      this.showToast("Failed to update data", "error");
    
      this.setState({ loading: false });}).finally(() => this.setState({ isSubmitting: false }));
  }

  componentDidMount() {
    this.Audit_log_configfetchHandler();
    
     
  }

  handletableNameChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({tableName: fieldValue });
};handleactionTypeChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({actionType: fieldValue });
};handleisEnabledChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({isEnabled: fieldValue });
};handlelogFieldsChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({logFields: fieldValue });
};handleretentionDaysChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({retentionDays: fieldValue });
};handlenotifyConfigChange = (e) => {
  e.preventDefault();
  const fieldValue = e.target.value;
  this.setState({notifyConfig: fieldValue });
};
  

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this audit_log_config?`)) {
      return;
    }
    
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('audit_log_config_Id', row.audit_log_config_Id);
    
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url +'C_Audit_log_config/delete', {
      method: 'POST', 
      mode: 'cors', 
      body: formData
    })
    .then(response => response.json())
    .then((data) => {
      this.showToast(data.message, data.status);
      if (data.status === "success") {
        this.Audit_log_configfetchHandler();
      }
    
      this.setState({ loading: false });})
    .catch((error) => {
      console.error("Delete error:", error);
      this.showToast("Failed to delete data", "error");
    
      this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];
    
    let inputElement;
    
    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;
        
      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;
        
      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;
        
      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;
        
      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;
        
      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;
        
      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;
        
      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }
    
    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;
    
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        )
      : this.state.data.slice(
          (this.state.currentPage - 1) * this.state.itemsPerPage,
          this.state.currentPage * this.state.itemsPerPage
        );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
      <div className="row">
        <div className="col-md-12 col-sm-12 col-xs-12">
          <div className="x_panel">
            <div className="x_content">
              <div
                id="datatable_wrapper"
                className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
              >
                <Row className="row">
                <div>
                 <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Audit Log Config</h3>
                </div>
            <Col
            className="d-flex justify-content-end"
            style={{ marginRight: "5px", marginTop: "20px" }}
          >
           {/* <Button
                variant="primary" style={{ float: "right", marginBottom: "10px" }}
                className="bi bi-plus "
                onClick={this.handleOffcanvasShow}
              >
              New
              </Button> */}

            {/* Enhanced Add Offcanvas */}
            <Offcanvas
              show={this.state.show && !this.state.isEditing}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Add Audit_log_config</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                  
                  {/* Error Summary */}
                  {Object.keys(errors).length > 0 && (
                    <div className="alert alert-danger mb-3">
                      <strong>Please fix the following errors:</strong>
                      <ul className="mb-0 mt-2">
                        {Object.entries(errors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handletableNameChange} className="form-control" name="tableName" value={this.state.tableName} required="required" placeholder="Enter tableName" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tableName} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Action Type</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleactionTypeChange} className="form-control" name="actionType" value={this.state.actionType} required="required" placeholder="Enter actionType" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.actionType} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is Enabled</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="number" onChange={this.handleisEnabledChange} className="form-control" name="isEnabled" value={this.state.isEnabled} required="required" placeholder="Enter isEnabled" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isEnabled} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Log Fields</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlelogFieldsChange} className="form-control" name="logFields" value={this.state.logFields} required="required" placeholder="Enter logFields" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.logFields} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Retention Days</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="number" onChange={this.handleretentionDaysChange} className="form-control" name="retentionDays" value={this.state.retentionDays} required="required" placeholder="Enter retentionDays" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retentionDays} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Notify Config</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlenotifyConfigChange} className="form-control" name="notifyConfig" value={this.state.notifyConfig} required="required" placeholder="Enter notifyConfig" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.notifyConfig} </div>
</Row><br />
                  {/* tableContent */}
                  {/* Auto-generated form content with validation */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.Audit_log_configsubmitHandler}
                        disabled={this.state.isSubmitting || !this.isFormValid()}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Saving...</>) : "Save"}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>

            {/* Enhanced Edit Offcanvas */}
            {this.state.isEditing && (
              <Offcanvas
              show={this.state.isEditing}
              onHide={this.handleOffcanvasClose}
              {...this.props}
              style={{ width: "500px" }}
              placement="end"
              backdrop="true"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Edit Audit_log_config</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Container style={{ "overflowY": "auto", height: "auto" }}>
                  
                  {/* Error Summary */}
                  {Object.keys(errors).length > 0 && (
                    <div className="alert alert-danger mb-3">
                      <strong>Please fix the following errors:</strong>
                      <ul className="mb-0 mt-2">
                        {Object.entries(errors).map(([field, error]) => (
                          <li key={field}>{error}</li>
                        ))}
                      </ul>
                    </div>
                  )}

                <Row className="divstyle">
                    <Row>
                      <Form>
                  <Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handletableNameChange} className="form-control" name="tableName" value={this.state.tableName} required="required" placeholder="Enter tableName" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.tableName} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Action Type</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handleactionTypeChange} className="form-control" name="actionType" value={this.state.actionType} required="required" placeholder="Enter actionType" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.actionType} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Is Enabled</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="number" onChange={this.handleisEnabledChange} className="form-control" name="isEnabled" value={this.state.isEnabled} required="required" placeholder="Enter isEnabled" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.isEnabled} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Log Fields</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlelogFieldsChange} className="form-control" name="logFields" value={this.state.logFields} required="required" placeholder="Enter logFields" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.logFields} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Retention Days</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="number" onChange={this.handleretentionDaysChange} className="form-control" name="retentionDays" value={this.state.retentionDays} required="required" placeholder="Enter retentionDays" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.retentionDays} </div>
</Row><br /><Row>
  <Col  lg="4" md="4">
  <Form.Label style={{ paddingTop: "8px" }}>Notify Config</Form.Label>
  </Col>
  <Col lg="8" md="8">
  <Form.Control type="text" onChange={this.handlenotifyConfigChange} className="form-control" name="notifyConfig" value={this.state.notifyConfig} required="required" placeholder="Enter notifyConfig" />
  </Col>  
  <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.notifyConfig} </div>
</Row><br />
                  {/* tableContent */}
                  {/* Auto-generated form content with validation */}
                  </Form>
                  </Row>
                  </Row>
                  <Row>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "50px" }}
                    >
                      <Button
                        className="button"
                        variant="success"
                        onClick={this.Audit_log_configupdateHandler}
                        disabled={this.state.isSubmitting || !this.isFormValid()}
                        style={{
                          marginTop: "20px",
                        }}
                      >
                        {this.state.isSubmitting ? (<><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="me-1" />Updating...</>) : "Update"}
                      </Button>
                    </Col>
                  </Row>
                </Container>
              </Offcanvas.Body>
            </Offcanvas>
            )}
        {/*offcanvas is over */}
                  </Col> 
                  </Row>
        <br />
        <Row>
  <div style={{ marginRight: "5px" }}>
    {/* searchbar,pagination,filter */}
    <input
      type="text"
      style={{ float: "left", marginBottom: "10px" }}
      onChange={this.handleFilter}
      placeholder="Search..."
    />
    <Button
      variant="primary"
      className="bi bi-plus"
      style={{ float: "right", marginBottom: "10px" }}
      onClick={this.handleOffcanvasShow}
    >
      New
    </Button>
    <DataTable
      data={paginatedData}
      columns={this.state.tableClms}
      pagination
      paginationServer
      paginationTotalRows={
        this.state.filteredData
          ? this.state.filteredData.length
          : this.state.data.length
      }
      onChangeRowsPerPage={this.handlePerRowsChange}
      onChangePage={this.handlePageChange}
      paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
      paginationPerPage={this.state.itemsPerPage}
      keyField="id"
      className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
    />
  </div>
</Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}